import axios from "axios";

export const uploadFileToS3 = async (file, callback, fileName) => {
  const parts = file.name.split(".");
  const fileExtension = parts[parts.length - 1];

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_PREDICTIONS_API}/api/upload`,
      { fileName, fileExtension }
    );

    await axios.put(data.signedUrl, file, {
      headers: { "Content-Type": file.type },
    });

    callback(data.fileUrl);
  } catch (err) {
    console.log(err);
  }
};